function _extends() {
  _extends = Object.assign
    ? Object.assign.bind()
    : function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
  return _extends.apply(this, arguments);
}

import React, { useContext } from "react";
import { Box, ResponsiveContext, Text } from "grommet";
import { MESSAGES } from "../../../const/messages";
import { getLSValue } from "../../../utils/storage";
import { isMobileTabletResponsive } from "../../../utils/utils";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { makeValidationSchema } from "./makeValidationSchema";
import { TextInput } from "../../Inputs/TextInput";
import { DefaultButton } from "../../Buttons/DefaultButton";
export var EmailForm = function EmailForm(_ref) {
  var changeEmailStatus = _ref.changeEmailStatus,
    setNewMail = _ref.setNewMail;
  var validateForm = makeValidationSchema();
  var user = localStorage.user && JSON.parse(localStorage.user);

  var _useForm = useForm({
      resolver: yupResolver(validateForm),
      shouldFocusError: false,
      defaultValues: {
        email: (user == null ? void 0 : user.email) || "",
      },
    }),
    handleSubmit = _useForm.handleSubmit,
    control = _useForm.control,
    errors = _useForm.formState.errors,
    clearErrors = _useForm.clearErrors,
    setValue = _useForm.setValue;

  var size = useContext(ResponsiveContext);
  var isMobileWidth = isMobileTabletResponsive(size);

  var onSubmit = function onSubmit(data) {
    return setNewMail(data);
  };

  return /*#__PURE__*/ React.createElement(
    "form",
    {
      onSubmit: handleSubmit(onSubmit),
    },
    /*#__PURE__*/ React.createElement(
      Box,
      {
        style: {
          borderRadius: "10px",
          backgroundColor: "#F8F8F8",
        },
        pad: "2rem",
      },
      /*#__PURE__*/ React.createElement(
        Box,
        {
          flex: true,
          direction: isMobileWidth ? "column" : "row",
          gap: isMobileWidth ? "1rem" : "2rem",
        },
        /*#__PURE__*/ React.createElement(
          Box,
          {
            width: isMobileWidth ? "100%" : "48%",
          },
          /*#__PURE__*/ React.createElement(Controller, {
            name: "email",
            control: control,
            render: function render(_ref2) {
              var _errors$email;

              var field = _ref2.field;
              return /*#__PURE__*/ React.createElement(
                TextInput,
                _extends(
                  {
                    error: (_errors$email = errors.email) == null ? void 0 : _errors$email.message,
                    handleFocus: function handleFocus() {
                      return clearErrors("email");
                    },
                    handleChange: function handleChange(e) {
                      return setValue(e.target.value);
                    },
                    name: "email",
                    iconSrc: "email",
                    iconWidth: "20px",
                    iconTop: "16px",
                    iconLeft: "20px",
                    iconColor: "#737373",
                    id: "profile-email",
                    defaultValue: user == null ? void 0 : user.email,
                    label: "\u0412\u0430\u0448 email",
                  },
                  field
                )
              );
            },
          })
        ),
        /*#__PURE__*/ React.createElement(
          Box,
          {
            flex: true,
            direction: "column",
          },
          /*#__PURE__*/ React.createElement(
            Box,
            {
              flex: true,
              height: "4.8rem",
              margin: {
                bottom: isMobileWidth && "1rem",
              },
            },
            changeEmailStatus.length
              ? /*#__PURE__*/ React.createElement(
                  Text,
                  {
                    size: "small",
                  },
                  changeEmailStatus
                )
              : null
          ),
          /*#__PURE__*/ React.createElement(DefaultButton, {
            width: "406px",
            type: "submit",
            caption:
              changeEmailStatus === MESSAGES.EMAIL_NOT_CONFIRM
                ? "Подтвердить почту"
                : getLSValue("user", "email")
                ? "Изменить почту"
                : "Добавить почту",
          })
        )
      )
    )
  );
};
